import { useEffect, useState } from 'react';
import { Loader2, Lock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../../lib/api';
import { useAuth } from '../../context/AuthContext';
import FeedComposer from '../../components/FeedComposer';
import PostCard from '../../components/PostCard';

export default function MemberFeed() {
  const { user } = useAuth();
  const isMember = user?.role === 'member' || user?.role === 'admin' || user?.role === 'superadmin';
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [locked, setLocked] = useState(false);

  useEffect(() => {
    api
      .get('/community/posts')
      .then(({ data }) => setPosts(data))
      .catch((err) => {
        if (err.response?.status === 403) setLocked(true);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleLike = async (postId) => {
    try {
      const { data } = await api.post(`/community/posts/${postId}/like`);
      setPosts((prev) => prev.map((p) => (p.post_id === postId ? { ...p, liked_by_me: data.liked, like_count: data.like_count } : p)));
    } catch {
      toast.error('No se pudo registrar tu reacción.');
    }
  };

  const handleCreated = (post) => setPosts((prev) => [post, ...prev]);

  if (locked || (!isMember && !loading)) {
    return (
      <div className="mx-auto flex max-w-lg flex-col items-center rounded-3xl border border-slate-200 bg-white px-8 py-16 text-center" data-testid="feed-locked">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-cnib-blue/10">
          <Lock className="h-8 w-8 text-cnib-blue" />
        </span>
        <h2 className="mt-6 font-heading text-2xl font-bold text-slate-900">El feed es exclusivo para socios</h2>
        <p className="mt-2 text-slate-600">Activa tu membresía para participar en la red profesional CNIB.</p>
        <Link to="/hagase-socio" className="mt-6 rounded-full bg-orange-500 px-7 py-3 font-bold text-white transition-colors hover:bg-orange-600">
          Hágase socio
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl space-y-4" data-testid="member-feed">
      <div className="hidden sm:block">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-orange-500">Comunidad</p>
        <h1 className="mt-1 font-heading text-2xl font-extrabold text-slate-900 sm:text-3xl">Feed profesional</h1>
      </div>

      <FeedComposer user={user} onCreated={handleCreated} />

      {loading ? (
        <div className="flex justify-center py-12">
          <Loader2 className="h-8 w-8 animate-spin text-cnib-blue" />
        </div>
      ) : posts.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-slate-300 bg-white py-14 text-center text-sm text-slate-500" data-testid="feed-empty">
          Sé el primero en publicar en la red.
        </div>
      ) : (
        <div className="space-y-4" data-testid="feed-posts-list">
          {posts.map((post) => (
            <PostCard key={post.post_id} post={post} onLike={handleLike} />
          ))}
        </div>
      )}
    </div>
  );
}
